import { forwardRef } from 'react';
import {
  StyledFieldSelect,
  StyledFieldSelectIcon,
  StyledFieldSelectWrapper,
} from './styled';
import { useFieldContext } from '../../../contexts/field';

const FieldSelect = forwardRef((props, ref) => {
  const { inputProps } = useFieldContext();

  return (
    <StyledFieldSelectWrapper>
      <StyledFieldSelect {...inputProps(ref, props)} />
      <StyledFieldSelectIcon />
    </StyledFieldSelectWrapper>
  );
});

export default FieldSelect;
